module.exports = __webpack_public_path__ + "d8fa7d09e6284007e5a4adca7e41b75b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/meredicte_512b_text.png
// module id = 320
// module chunks = 1